import withComponent from "@/hoc/withComponent"
import styled from "styled-components"
import { 
    feat1Svg,
    feat2Svg,
    feat3Svg,
    feat4Svg,
    feat5Svg,
    feat6Svg,
} from "../svg"

const FeatureListStyled = styled.div`
    font-family: PingFangSC, PingFang SC;
    padding-top: 110px;
    background: #FFFFFF;
    .feature-h1 {
        font-size: 36px;
        font-weight: 500;
        color: #333333;
        margin-bottom: 24px;
        text-align: center;
    }

    .feature-p {
        font-size: 18px;
        font-weight: 400;
        color: #555555;
        margin-bottom: 36px;
        text-align: center;
    }

    .feature-list {
        display: grid;
        grid-template-columns: 1fr 1fr;
        row-gap: 40px;
        column-gap: 100px;
    }
    .feature-item-svg {
        width: 80px;
        height: 80px;
        background: rgba(17,187,166,0.1);
        border-radius: 50%;

        svg {
            width: 52px;
            height: 52px;
        }
    }
`

const list = [
    {
        svg: feat1Svg,
        title: '自动排版',
        p: '只需填写内容，程序会自动排版出精美的简历',
    },
    {
        svg: feat2Svg,
        title: '模块定制',
        p: '所有简历模块皆可自由调整、隐藏或显示',
    },
    // {
    //     svg: feat3Svg,
    //     title: '皮肤色彩定制',
    //     p: '千万种皮肤随心定制，做出独一无二的简历',
    // },
    // {
    //     svg: feat4Svg,
    //     title: '支持中英文',
    //     p: '中英文一键切换，字体可修改',
    // },
    {
        svg: feat5Svg,
        title: '一键换模板',
        p: '填写一份简历，一键切换海量模板',
    },
    {
        svg: feat6Svg,
        title: '一键下载',
        p: '一键下载简历，轻松打印投递',
    },
]

const Pad = () => {




    return <FeatureListStyled>
        <div className="feature-h1">简历手机端 随时随地编辑</div>
        <div className="feature-p">支持简历小程序、h5页面</div>
        <div className="feature-list" style={{ width: '100%', margin: '0 auto',
                display: 'flex',
                justifyContent: 'center',
                margin: '0px auto',
                background: 'linear-gradient( 180deg, #FFFFFF 0%, #F7F7F7 100%)'
        }}>
            <img src='https://pub.jianzeppt.cn/image/padPhone.png' style={{height:'740px',    width: '100%',objectFit:'contain'}}>
            </img>
        </div>
    </FeatureListStyled>
}

export default withComponent(Pad)